import { useCallback } from 'react';

import { useSaleCatalogQuery } from '@/lib/entities/sale/lib';

export const usePagination = () => {
  const { query, setQuery } = useSaleCatalogQuery();
  const setNextPage = useCallback(() => {
    setQuery(
      {
        page: query.page + 1,
        type: query.type,
        phuketDistrict: query.phuketDistrict,
        samuiDistrict: query.samuiDistrict,
      },
      { scroll: true }
    );
  }, [
    setQuery,
    query.page,
    query.type,
    query.phuketDistrict,
    query.samuiDistrict,
  ]);

  const setPrevPage = useCallback(() => {
    setQuery(
      {
        page: query.page - 1,
        type: query.type,
        phuketDistrict: query.phuketDistrict,
        samuiDistrict: query.samuiDistrict,
      },
      { scroll: true }
    );
  }, [
    setQuery,
    query.page,
    query.type,
    query.phuketDistrict,
    query.samuiDistrict,
  ]);

  const jumpToPage = useCallback(
    (num: number) => {
      setQuery(
        {
          page: num,
          type: query.type,
          phuketDistrict: query.phuketDistrict,
          samuiDistrict: query.samuiDistrict,
        },
        { scroll: true }
      );
    },
    [query.type, query.phuketDistrict, query.samuiDistrict, setQuery]
  );

  return { setNextPage, setPrevPage, jumpToPage };
};
